<script>
    import Layout from "../../layouts/main";
    import PageHeader from "../../components/page-header";
    import brandList from "./brand-list";
    export default {
    components: { Layout, PageHeader, brandList },
    data() {
        return {};
    }
    };

</script>

<template>
  <Layout>
    <brand-list/>
  </Layout>
</template>